import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    chartData: Object,
    totalErrors: Number
  };

  connect() {
    this.initChart();
  }

  initChart() {
    if (this.totalErrorsValue === 0) {
      return;
    }

    const canvas = this.element.querySelector('canvas');
    if (!canvas || !window.Chart) {
      return;
    }

    const ctx = canvas.getContext('2d');

    const labels = Object.keys(this.chartDataValue);
    const data = Object.values(this.chartDataValue);
    // Use danger red for all banks
    const colors = data.map(() => '#dc3545');

    new window.Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 2,
          borderColor: '#fff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const percentage = ((context.parsed / this.totalErrorsValue) * 100).toFixed(1);
                return context.label + ': ' + context.parsed + ' errors (' + percentage + '%)';
              }
            }
          }
        },
        cutout: '60%'
      }
    });
  }
}
